import { AddToCartOption } from '@/types/productPage';

export type AddToCartButtonProps = {
  id?: string;
  addToCartOption: AddToCartOption;
  handleAddToCart: () => Promise<void>;
  disabled?: boolean;
};

export enum ButtonVariants {
  addToCard,
  specialOrders,
  preOrder,
  info,
  productDetails,
  notAvailble,
  contactUs,
  viewAdditionalItems,
}
